import React from 'react';
import AeroIcon from './AeroIcon';
import AeroDotLoader from './AeroDotLoader';
import { NOTE_COPY as C } from '../../utils/figmaLinkCopy';
import './AeroFigmaLinkNote.css';

/**
 * AeroFigmaLinkNote: the line under a Figma link field (Aero's look; Figmafolio's twin is
 * ViewportEditor/FigmaLinkNote.js, same words from utils/figmaLinkCopy.js, same logic from
 * utils/useFigmaLinkRows.js).
 *
 *   kind  'converted' | 'checking' | 'viewable' | 'not_viewable' | 'not_figma' | 'unsupported'
 *         null shows nothing (and so does 'unknown': a check that could not run must not cry wolf)
 *   onShowHow, onRecheck  the two actions on the not shared note
 *
 * Flat, tokens only, own `.aero-linknote*` classes (works in or out of `.ut-theme`).
 */
export default function AeroFigmaLinkNote({ kind, onShowHow, onRecheck }) {
  if (kind === 'converted') {
    return (
      <div className="aero-linknote aero-linknote-line is-quiet" role="status">
        <AeroIcon name="link" />
        <span>{C.converted}</span>
      </div>
    );
  }
  if (kind === 'checking') {
    return (
      <div className="aero-linknote aero-linknote-line is-pending" role="status">
        <AeroDotLoader size="sm" />
        <span>{C.checking}</span>
      </div>
    );
  }
  if (kind === 'viewable') {
    return (
      <div className="aero-linknote aero-linknote-line is-ok" role="status">
        <AeroIcon name="check" />
        <span>{C.viewable}</span>
      </div>
    );
  }
  if (kind === 'not_viewable') {
    return (
      <div className="aero-linknote aero-linknote-box is-error" role="alert">
        <span className="aero-linknote-mark" aria-hidden="true"><AeroIcon name="alert" /></span>
        <div className="aero-linknote-text">
          <b>{C.notViewable.head}</b>
          <span>{C.notViewable.body}</span>
          <div className="aero-linknote-actions">
            <button type="button" className="aero-linknote-btn" onClick={onShowHow}>{C.notViewable.show}</button>
            <button type="button" className="aero-linknote-link" onClick={onRecheck}>{C.notViewable.again}</button>
          </div>
        </div>
      </div>
    );
  }
  if (kind === 'not_figma' || kind === 'unsupported') {
    const copy = kind === 'not_figma' ? C.notFigma : C.unsupported;
    return (
      <div className="aero-linknote aero-linknote-box is-warn" role="alert">
        <span className="aero-linknote-mark" aria-hidden="true"><AeroIcon name="info" /></span>
        <div className="aero-linknote-text">
          <b>{copy.head}</b>
          <span>{copy.body}</span>
        </div>
      </div>
    );
  }
  return null;
}
